





























































































































import { Component, Vue, Prop } from "vue-property-decorator";
import { MESSAGE } from "@/model/Message";
import { Getter, Action } from "vuex-class";
import { Utils } from "@/service/util";
import requestService from "@/service/requestService";
import { ElInput } from "element-ui/types/input";
import { KatashikiParams } from "@/model/KatashikiParams";
import { SknUketsukeExtends } from "@/model/SknUketsukeExtends";

@Component
export default class NisseirenJunseiSearchDialog extends Vue {
  @Prop() code: string;
  @Prop() value: number;
  @Prop({ default: true })
  data!: any;

  @Getter("sknUketsukeExtends", { namespace: "ReservationDetail" })
  sknUketsukeExtends: SknUketsukeExtends;

  @Getter("uketsukeExtendsId", { namespace: "ReservationDetail" })
  uketsukeExtendsId: number;

  @Getter("getKatashikiParams", { namespace: "KatashikiStore" })
  katashikiParams: KatashikiParams;

  reqService: requestService;
  hasNisseirenData: boolean = false;
  hasJunseiData: boolean = false;
  loadingNisseiren: boolean = true;
  loadingJunsei: boolean = true;
  loadingText: string = MESSAGE.Loading;
  errorMessage: string = "";
  appendToBody: string = "";
  showDialog: boolean = false;
  isJunseiOnly: boolean = false; // trueの場合、日整連作業欄を非活性にする（作業部品ダイアログの「純正部品検索」ボタンで開いた場合など）
  isUseJunseiBuhin: boolean = false; // trueの場合、純正部品欄を活性にする（FunctionSettingのisUseNisseirenが2の場合にtrue、1の場合にfalse）
  nisseirenSelectData: any = {
    id : 0 ,
    nisseirenCd : 0 ,
    nisseirenNm : ""
  };

  $refs!: {
    searchSeibiTitleInput: ElInput;
    searchHinmeiInput: ElInput;
  };

  nisseirenColumns: any = [];
  junseiColumns: any = [];
  nisseirenTableData: any = [];
  junseiTableData: any = [];

  schSeibiTitle: string = "";
  schHinmei: string = "";
  public utils: Utils = new Utils();

  created() {
    this.reqService = new requestService();
    this.loadingNisseiren = false;
    this.loadingJunsei = false;
  }

  onOpen(isJunseiOnly: boolean, isUseJunseiBuhin: boolean) {
    this.isJunseiOnly = isJunseiOnly;
    this.isUseJunseiBuhin = isUseJunseiBuhin;
    this.showDialog = true;
    this.errorMessage = "";
  }

  onDialog() { 
    // 開いた際にフォーカスを設定する
    if (this.isUseJunseiBuhin && this.isJunseiOnly && this.$refs.searchHinmeiInput) {
      this.$refs.searchHinmeiInput.focus(); // 純正部品
    } else if (this.$refs.searchSeibiTitleInput) {
      this.$refs.searchSeibiTitleInput.focus(); // 日整連作業
    }
  }

  onClose() {
    this.showDialog = false;
    this.clearDialogData();
  }

  // 日整連作業のテーブル幅指定
  setNisseirenTableColumnWidth(index: number) {
    switch(index) {
      case 0:
        return "70px";
      case 2:
        return "80px";
      case 3:
        return "80px";
      default:
        return;
    }
  }

  // 純正部品のテーブル幅指定
  setJunseiTableColumnWidth(index: number) {
    switch(index) {
      case 0:
        return "95px";
      case 2:
      case 3:
        return "60px";
      case 4:
        return "60px";
      default:
        return;
    }
  }

  searchNisseirenWorkBySeibiTitle() {
    const nisseirenColumns: any = [{header: "作業番号", key: "sknNisseirenCd"}
                                  ,{header: "日整連作業 名称", key: "nisseirenSeibiTitle"}
                                  ,{header: "工数", key: "kousuu"}
                                  ,{header: "数量", key: "num"}];
    this.$set(this, "nisseirenColumns", nisseirenColumns);

    let nisseirenTableData: any = [];
    this.nisseirenSelectData = { id:0 , nisseirenCd:0 , nisseirenNm : "" };
    this.loadingNisseiren = true;
    this.$set(this, "hasNisseirenData", false);
    this.reqService.getNisseirenWorkBySeibiTitle(
      this.katashikiParams.modelCd
      , this.katashikiParams.nisseirenKatashiki
      , this.katashikiParams.nisseirenEngineKatashiki
      , this.katashikiParams.kakyukiKbn
      , this.uketsukeExtendsId
      , this.schSeibiTitle
      , this.sknUketsukeExtends.sknSeibiShubetsuKbn || 0
    ).then((data: any) => {
      let nisseirenCd: number = 0;
      data.forEach((item: any) => {
        // 同じ日整連コードが連続する項目の2つ目以降はオプション項目
        let checkKey: boolean = ( nisseirenCd == item.sknNisseirenCd );
        nisseirenCd = item.sknNisseirenCd;

        nisseirenTableData.push({"view": {"sknNisseirenCd": item.sknNisseirenCd
                                        , "nisseirenSeibiTitle": item.nisseirenSeibiTitle
                                        , "nisseirenSeibiTitleAdd": item.nisseirenSeibiTitleAdd
                                        , "kousuu": item.kousuu
                                        , "num": 0}
                                ,"selected": false
                                ,"kousuuPlus": checkKey
                                ,"item": item});
      });

      
    }).catch(() => {
      // console.error(err);
    }).then(() => {
      this.loadingNisseiren = false;
      this.$set(this, "hasNisseirenData", true);
      this.$set(this, "nisseirenTableData", nisseirenTableData);
    });
  }

  setFoundJunseiBuhinByNisseirenWork(item: any) {
    const junseiColumns: any = [{header: "品番", key: "hinban"}
                              ,{header: "純正部品 名称", key: "buhinNm"}
                              ,{header: "始期", key: "gengoShiki"}
                              ,{header: "終期", key: "gengoShuuki"}
                              ,{header: "単価", key: "kingakuZn"}];
    this.$set(this, "junseiColumns", junseiColumns);

    let junseiTableData: any = [];
    this.loadingJunsei = true;
    this.$set(this, "hasJunseiData", false);
    this.reqService.getJunseiBuhinByNisseirenWork(
      this.katashikiParams.katashikiShiteiNo
      , this.katashikiParams.ruibetsuKubunNo
      , this.katashikiParams.junseiKatashiki
      , this.katashikiParams.junseiEngineKatashiki
      , this.katashikiParams.syaryouShiki
      , this.katashikiParams.syaryouShuki
      , item.sknNisseirenCd
    ).then((res: any) => {
      res.forEach((data: any) => {
        junseiTableData.push({"view": {"hinban": data.hinban
                                      , "buhinNm": data.buhinNm
                                      , "gengoShiki": data.gengoShiki
                                      , "gengoShuuki": data.gengoShuuki
                                      , "kingakuZn": Number(data.kingakuZn).toLocaleString()}
                              ,"selected": false
                              ,"item": data});
      });
    }).catch(() => {
      // console.error(err);
    }).then(() => {
      this.loadingJunsei = false;
      this.$set(this, "hasJunseiData", true);
      this.$set(this, "junseiTableData", junseiTableData);
    });
  }

  searchJunseiBuhinByHinmei() {
    const junseiColumns: any = [{header: "品番", key: "hinban"}
                              ,{header: "純正部品 名称", key: "buhinNm"}
                              ,{header: "始期", key: "gengoShiki"}
                              ,{header: "終期", key: "gengoShuuki"}
                              ,{header: "単価", key: "kingakuZn"}];
    this.$set(this, "junseiColumns", junseiColumns);

    let junseiTableData: any = [];
    this.loadingJunsei = true;
    this.$set(this, "hasJunseiData", false);
    this.reqService.getJunseiBuhinByHinmei(
      this.katashikiParams.katashikiShiteiNo
      , this.katashikiParams.ruibetsuKubunNo
      , this.katashikiParams.junseiKatashiki
      , this.katashikiParams.junseiEngineKatashiki
      , this.katashikiParams.syaryouShiki
      , this.katashikiParams.syaryouShuki
      , this.schHinmei
    ).then((data: any) => {
      data.forEach((item: any) => {
        junseiTableData.push({"view": {"hinban": item.hinban
                                      , "buhinNm": item.buhinNm
                                      , "gengoShiki": item.gengoShiki
                                      , "gengoShuuki": item.gengoShuuki
                                      , "kingakuZn": Number(item.kingakuZn).toLocaleString()}
                              ,"selected": false
                              ,"item": item});
      });
    }).catch(() => {
      // console.error(err);
    }).then(() => {
      this.loadingJunsei = false;
      this.$set(this, "hasJunseiData", true);
      this.$set(this, "junseiTableData", junseiTableData);
    });
  }

  // 日整連作業を選択
  selectNisseirenWork(item: any, index: number) {
    // 選択内容を記録
    this.nisseirenSelectData.id = index; 
    this.nisseirenSelectData.nisseirenCd = this.nisseirenTableData[index].view.sknNisseirenCd;
    this.nisseirenSelectData.nisseirenNm = this.nisseirenTableData[index].view.nisseirenSeibiTitle;

    // 初期化しつつ選択中の日整連コードを元に同じコードの項目をすべて選択状態にする
    this.nisseirenTableData.forEach((row: any) => {
      row.selected = false;
      row.view.num = 0;
      if (row.view.sknNisseirenCd == this.nisseirenSelectData.nisseirenCd) {
        row.selected = true;
      }
    });

    // 選択した項目のみ行う処理
    // this.nisseirenTableData[index].selected = true; // 選択
    this.nisseirenTableData[index].view.num = 1; // 数量 (オプション項目でない、メインの項目に行う)

    this.$set(this, "junseiTableData", []);
    if (this.isUseJunseiBuhin) {
      this.setFoundJunseiBuhinByNisseirenWork(item);
    }
  }

  // 数量切り替え
  chengeNisseirenKousuu() {
    let kousuu: number = 0;
    this.nisseirenTableData.forEach((row: any) => {
      if ( row.selected ) {
        kousuu += row.view.kousuu * 10 * row.view.num; // 小数計算の誤差回避
      }
    });
    return kousuu / 10;
  }

  // 純正部品を選択
  selectJunseiBuhin(item: any, index: number) {
    if (this.junseiTableData[index].selected) {
      this.junseiTableData[index].selected = false;
    } else {
      this.junseiTableData[index].selected = true;
    }
  }

  NisseirenJunseiRowClassName(item: any) {
    if (item.row.selected === true) {
      return "nisseiren-junsei-row-selected";
    } else {
      return "";
    }
  }

  // データクリア
  clearDialogData() {
    this.schSeibiTitle = "";
    this.schHinmei = "";
    this.nisseirenTableData = [];
    this.junseiTableData = [];
    this.nisseirenSelectData = { id:0 , nisseirenCd:0 , nisseirenNm : "" };
    this.hasNisseirenData = false;
    this.hasJunseiData = false;
  }

  // 確定
  onConfirmNisseirenJunsei() {
    let filteredNisseirenWork: any = [];
    if ( this.nisseirenSelectData.nisseirenCd != 0 ) {
      let cacheRow = this.utils.deepCopy(this.nisseirenTableData[ this.nisseirenSelectData.id ].item);
      // 数量を加味した数値に書き換え
      cacheRow.kousuu = 0;
      cacheRow.kouchinZk = 0;
      cacheRow.kouchinZn = 0;
      this.nisseirenTableData.map((row: any) => {
        if (row.selected) {
          cacheRow.kousuu    += row.item.kousuu * 10 * row.view.num; // 小数計算の誤差回避
          cacheRow.kouchinZk += row.item.kouchinZk * row.view.num;
          cacheRow.kouchinZn += row.item.kouchinZn * row.view.num;
        }
      });
      cacheRow.kousuu = cacheRow.kousuu / 10;
      // 格納
      filteredNisseirenWork.push(cacheRow);
    }
    let filteredJunseiBuhin: any = [];
    this.junseiTableData.map((row: any) => {
      if (row.selected) {
        filteredJunseiBuhin.push(row.item);
      }
    });

    this.$emit("onNisseirenJunseiSelected", 
      {"filteredNisseirenWork": filteredNisseirenWork, "filteredJunseiBuhin": filteredJunseiBuhin});
    this.onClose();
  }

  // getDataError(error: string) {
  //   this.loading = false;
  //   this.errorMessage = error;
  // }
}
